$(function() {
  return $(document).on('change', '.payment_form', function() {
    if (['0'].includes($(this).val())){
      $(this).parent().parent().find(".transaction_code").addClass('hidden')
      $(this).parent().parent().find(".due_date").addClass('hidden')
    } else if (['1', '2', '3', '4'].includes($(this).val())){
      $(this).parent().parent().find(".due_date").addClass('hidden')
      $(this).parent().parent().find(".transaction_code").removeClass('hidden')
    } else {
      $(this).parent().parent().find(".transaction_code").addClass('hidden')
      $(this).parent().parent().find(".due_date").removeClass('hidden')
    }  
  })
})

$(function() {
  return $(document).on('keyup', '.value-pay', function() {
    if (parseFloat($(this).val()) > 0){
      calculateDevuelta();
    }  
  })
})

$(function() {
  return $(document).on('click', '.remove_payment_form', function() {
    $(this).parent('.row').remove()
    calculateDevuelta();
  })
})

function roundDecimal(num, decimales = 2) {
  var signo = (num >= 0 ? 1 : -1);
  num = num * signo;
  if (decimales === 0) //con 0 decimales
      return signo * Math.round(num);
  // round(x * 10 ^ decimales)
  num = num.toString().split('e');
  num = Math.round(+(num[0] + 'e' + (num[1] ? (+num[1] + decimales) : decimales)));
  // x * 10 ^ (-decimales)
  num = num.toString().split('e');
  return signo * (num[0] + 'e' + (num[1] ? (+num[1] - decimales) : -decimales));
}

function calculateDevuelta() {
  total = roundDecimal( parseFloat($('#total-pay').attr('total')) )
  received = 0
  $( ".value-pay" ).each(function( index ) {
    received += parseFloat($( this ).val()); 
  });
  $('.received').text('$' + Intl.NumberFormat().format(received))
  devuelta = received - total
  if (devuelta >= 0) {
    $('.devuelta').removeClass('cl-red-dark').addClass('cl-green-dark')
  }else{
    $('.devuelta').removeClass('cl-green-dark').addClass('cl-red-dark')
  }
  $('.devuelta').text('$' + Intl.NumberFormat().format(devuelta))
}